import { AntLocale } from '../type'
import { merge } from 'lodash'
import antLang from 'ant-design-vue/lib/locale/pt_PT'

/**
 * @lang 葡萄牙语
 */
export default merge<Record<string, never>, AntLocale, PartialDeep<AntLocale>>(
  {},
  antLang,
  {
    Empty: {
      description: 'Sem Registros'
    }
  }
)
